import { h, render } from 'vue';
import ZSTooltip from '../components/zs-components/ZSTooltip.vue';

export default {
    beforeMount(el, binding) {
        // Create tooltip container
        const container = document.createElement('div');
        container.className = 'tooltip-container';
        container.style.position = 'absolute';
        container.style.zIndex = '9999999999';
        container.style.display = 'none';
        document.body.appendChild(container);

        // Store tooltip related data
        el._tooltipContainer = container;
        el._tooltipVisible = false;
        el._tooltipText = binding.value || '';
        el._tooltipPosition = binding.arg || 'top';

        // Extract background and foreground colors from modifiers
        const modifiers = binding.modifiers || {};
        const bgColors = {
            primary: '#0066cc',
            success: '#28a745',
            warning: '#ffc107',
            danger: '#dc3545',
            info: '#17a2b8',
            dark: '#343a40',
        };

        const fgColors = {
            white: '#ffffff',
            black: '#000000',
            light: '#f8f9fa',
            dark: '#212529',
        };

        // Default to undefined so the component can use its default colors
        el._tooltipBgColor = undefined;
        el._tooltipFgColor = undefined;

        // Check for color modifiers
        Object.keys(modifiers).forEach(key => {
            // Background colors
            if (bgColors[key]) {
                el._tooltipBgColor = bgColors[key];
            } else if (key.startsWith('bg-')) {
                // Support custom background colors with the format v-tooltip.bg-FF0000
                const colorCode = key.substring(3);
                if (/^[0-9A-Fa-f]{6}$/.test(colorCode)) {
                    el._tooltipBgColor = `#${colorCode}`;
                }
            }

            // Foreground colors
            else if (fgColors[key]) {
                el._tooltipFgColor = fgColors[key];
            } else if (key.startsWith('fg-')) {
                // Support custom foreground colors with the format v-tooltip.fg-FF0000
                const colorCode = key.substring(3);
                if (/^[0-9A-Fa-f]{6}$/.test(colorCode)) {
                    el._tooltipFgColor = `#${colorCode}`;
                }
            }
        });

        // Create the mouseenter event
        el._showTooltip = () => {
            el._tooltipVisible = true;
            const rect = el.getBoundingClientRect();
            const tooltipVNode = h(ZSTooltip, {
                msg: el._tooltipText,
                position: el._tooltipPosition,
                show: true,
                bgColor: el._tooltipBgColor, // Pass the background color to the component
                fgColor: el._tooltipFgColor, // Pass the foreground color to the component
            });

            render(tooltipVNode, el._tooltipContainer);
            el._tooltipContainer.style.display = 'block';

            // Position the tooltip based on element position and tooltip position
            const containerRect = el._tooltipContainer.getBoundingClientRect();

            switch (el._tooltipPosition) {
                case 'top':
                    el._tooltipContainer.style.left = `${rect.left + rect.width / 2 - containerRect.width / 2}px`;
                    el._tooltipContainer.style.top = `${rect.top - containerRect.height - 5}px`;
                    break;
                case 'bottom':
                    el._tooltipContainer.style.left = `${rect.left + rect.width / 2 - containerRect.width / 2}px`;
                    el._tooltipContainer.style.top = `${rect.bottom + 5}px`;
                    break;
                case 'left':
                    el._tooltipContainer.style.left = `${rect.left - containerRect.width - 5}px`;
                    el._tooltipContainer.style.top = `${rect.top + rect.height / 2 - containerRect.height / 2}px`;
                    break;
                case 'right':
                    el._tooltipContainer.style.left = `${rect.right + 5}px`;
                    el._tooltipContainer.style.top = `${rect.top + rect.height / 2 - containerRect.height / 2}px`;
                    break;
                default:
                    el._tooltipContainer.style.left = `${rect.left + rect.width / 2 - containerRect.width / 2}px`;
                    el._tooltipContainer.style.top = `${rect.top - containerRect.height - 5}px`;
            }
        };

        // Create the mouseleave event
        el._hideTooltip = () => {
            el._tooltipVisible = false;
            el._tooltipContainer.style.display = 'none';
            render(null, el._tooltipContainer);
        };

        // Add event listeners
        el.addEventListener('mouseenter', el._showTooltip);
        el.addEventListener('mouseleave', el._hideTooltip);
    },

    updated(el, binding) {
        // Update the tooltip text and position when directive value changes
        el._tooltipText = binding.value || '';
        el._tooltipPosition = binding.arg || 'top';
    },

    beforeUnmount(el) {
        // Clean up event listeners and DOM elements
        el.removeEventListener('mouseenter', el._showTooltip);
        el.removeEventListener('mouseleave', el._hideTooltip);

        if (el._tooltipContainer) {
            render(null, el._tooltipContainer);
            document.body.removeChild(el._tooltipContainer);
        }
    }
};